module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "the-board-page"
    }
  }, [_c('h1', [_vm._v("The Board")]), _vm._v(" "), _c('div', {
    staticClass: "sort-mode-selector"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('button', {
    class: [{
      active: 0 === _vm.sortModeIndex
    }],
    on: {
      "click": function($event) {
        _vm.sortModeIndex = 0
      }
    }
  }, [_vm._v("Activity")]), _vm._v(" "), _c('button', {
    class: [{
      active: 1 === _vm.sortModeIndex
    }],
    on: {
      "click": function($event) {
        _vm.sortModeIndex = 1
      }
    }
  }, [_vm._v("New")]), _vm._v(" "), _c('button', {
    class: [{
      active: 2 === _vm.sortModeIndex
    }],
    on: {
      "click": function($event) {
        _vm.sortModeIndex = 2
      }
    }
  }, [_vm._v("Top")])])]), _vm._v(" "), _vm._l((_vm.posts), function(post) {
    return _c('div', {
      staticClass: "content-box board-post"
    }, [_c('section', {
      staticClass: "votes"
    }), _vm._v(" "), _c('header', [_c('section', {
      staticClass: "post-info"
    }, [_vm._v("Posted by\n                "), _c('router-link', {
      attrs: {
        "to": ("/Developer/" + (post.authorStringUrl))
      }
    }, [_c('i', {
      staticClass: "fas fa-user"
    }), _vm._v(" " + _vm._s(post.authorAlias))]), _vm._v("\n                on " + _vm._s(post.created) + ". Last activity at " + _vm._s(post.updated) + "\n            ")], 1), _vm._v(" "), _c('section', {
      staticClass: "title"
    }, [_vm._v(_vm._s(post.title))]), _vm._v(" "), _c('footer', [_c('i', {
      staticClass: "far fa-comment-alt"
    }), _vm._v(" " + _vm._s(post.commentCount) + " Comments")])])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b50d44a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/TheBoard/TheBoardPage.vue
// module id = 818
// module chunks = 2